import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'order-card',
  name: '订单卡片',
  icon: '单',
  group: '订单组件',
  description: '横向展示订单状态入口，可配置各状态显示与跳转',
  defaultProps: {
    title: '我的订单',
    orderListPath: '/pages/orders/index',
    statuses: [
      { key: 'ALL', label: '全部', icon: '', enabled: true, path: '' },
      { key: 'PENDING_PAY', label: '待支付', icon: '', enabled: true, path: '' },
      { key: 'PAID', label: '已支付', icon: '', enabled: true, path: '' },
      { key: 'USED', label: '已使用', icon: '', enabled: true, path: '' },
      { key: 'CANCELLED', label: '已取消', icon: '', enabled: true, path: '' }
    ]
  }
}